// extracted by mini-css-extract-plugin
export default {"ServantList":"ServantList_ServantList__VHf9W","searching":"ServantList_searching__hVGpn","parent":"ServantList_parent__cOOnd","myButton":"ServantList_myButton__46knA"};